import { useEffect } from "react";
import i18n from "./i18n";
import { I18N_LOCAL_STORAGE_KEY } from "./i18n-key";

export const useLanguageDetector = () => {
  useEffect(() => {
    const savedLanguage = localStorage.getItem(I18N_LOCAL_STORAGE_KEY);

    if (savedLanguage && (savedLanguage === "en" || savedLanguage === "pl")) {
      i18n.changeLanguage(savedLanguage);
    } else if (i18n.services.languageDetector) {
      const detected = i18n.services.languageDetector.detect();

      const detectedLang = Array.isArray(detected) ? detected[0] : detected;

      let normalizedLang = detectedLang;
      if (
        typeof detectedLang === "string" &&
        detectedLang.toLowerCase().includes("en")
      ) {
        normalizedLang = "en";
      } else if (
        typeof detectedLang === "string" &&
        detectedLang.toLowerCase().includes("pl")
      ) {
        normalizedLang = "pl";
      }

      if (
        normalizedLang &&
        (normalizedLang === "en" || normalizedLang === "pl")
      ) {
        i18n.changeLanguage(normalizedLang);
      }
    }
  }, []);
};
